import React from 'react'

import {  Link } from "react-router-dom";

import { Button, Row, Col, Card, Alert } from "react-bootstrap";

import france from "../images/france.svg"
import spain from "../images/spain.svg"
import italy from "../images/italy.svg"
import romania from "../images/romania.svg"

import logo from "../images/logo.svg"
import Footer from './footer/Footer';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';


const Home = () => {

    const check = (props) => {

        if (localStorage.getItem("levelCount") === null) {
            localStorage.setItem('levelCount', 0);
          };

          if (localStorage.getItem("language") === null) {
            localStorage.setItem('language', `${props}`);
          } else if(localStorage.getItem("language") === `${props}`){
              return null;
          } else {
            localStorage.setItem('language', `${props}`);
          };
    };


    const AlertNotice = () => {

      if(localStorage.getItem("language") !== null){

        if(localStorage.getItem("language") === 'es-ES'){

          return (
            <center>
            <Alert variant={'danger'} style={{backgroundColor: "#DC45DF", border: 'none', color: 'white', maxWidth: '80%', textAlign: 'center', marginTop: '20px'}}>
            Please note, you've specified Spanish already. Picking another may overwrite your progress/levels.
          </Alert>
            </center>
          );

        } else if(localStorage.getItem("language") === 'fr-FR'){

          return (
            <>
            <center>
            <Alert variant={'danger'} style={{backgroundColor: "#DC45DF", border: 'none', color: 'white', maxWidth: '80%', textAlign: 'center', marginTop: '20px'}}>
            Please note, you've specified French already. Picking another may overwrite your progress/levels.
          </Alert>
            </center>
            </>
          );

        } else if(localStorage.getItem("language") === 'it-IT'){

          return (
            <>
           <center>
            <Alert variant={'danger'} style={{backgroundColor: "#DC45DF", border: 'none', color: 'white', maxWidth: '80%', textAlign: 'center', marginTop: '20px'}}>
            Please note, you've specified Italian already. Picking another may overwrite your progress/levels.
          </Alert>
            </center>
            </>
          );

        } else if(localStorage.getItem("language") === 'ro-RO'){

          return (
            <>
            <center>
            <Alert variant={'danger'} style={{backgroundColor: "#DC45DF", border: 'none', color: 'white', maxWidth: '80%', textAlign: 'center', marginTop: '20px'}}>
            Please note, you've specified Romanian already. Picking another may overwrite your progress/levels.
          </Alert>
            </center>
            </>
          );

        }

      }
    };


    return (
      <div style={{ overflow: 'hidden'}}>
        <div style={{backgroundColor: "#141332", paddingLeft: '5%', paddingRight: '5%', paddingBottom:'5%'}}>
          <Row>
            <Col>
            <Link to="/"><ArrowBackIosIcon style={{margin: '5%', color: 'white'}}/></Link>
            </Col>
            <Col>
            <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
            </Col>
          </Row>
          <center>
      <Card style={{backgroundColor: "#1D1D41", padding: '7%'}} data-aos="fade-up" data-aos-duration="1500">
        <Card.Body >
        <Row style={{padding: '0%'}}>
        <h1  style={{color: 'white', fontWeight: '600'}}>What language are you learning?</h1>
        {<AlertNotice/>}
      </Row>
      <Row style={{padding: '10%', color: 'white'}}>
        <Col><center><Link to="/levels"><img onClick={()=>{check('it-IT')}} src={italy} /></Link><br/><br/><h4>Italian</h4></center></Col>
        <Col><center><Link to="/levels"><img onClick={()=>{check('fr-FR')}} src={france} /></Link><br/><br/><h4>French <br/>(European)</h4></center></Col>
        <Col><center><Link to="/levels"><img onClick={()=>{check('es-ES')}} src={spain} /></Link><br/><br/><h4>Spanish (European)</h4></center></Col>
        <Col><center><Link to="/levels"><img onClick={()=>{check('ro-RO')}} src={romania} /></Link><br/><br/><h4>Romanian</h4></center></Col>

      </Row>
        </Card.Body>
      </Card>
      </center>
        </div>
        <Footer/>
        </div>
    )


}

export default Home;